import React from 'react';
import { Box, Typography, Chip, Paper, Divider } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import { useSystemConfig } from '../../../contexts/SystemConfigContext';

const appVersion = require('../../../../package.json').version;

const About = () => {
    const { config } = useSystemConfig();
    const product = config && config.product ? config.product : null;

    return (
        <div className='page-content'>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ px: 2, pt: 1 }}>
                    <AreaTitle
                        Title="Sobre"
                        Description="Informações sobre o sistema e a versão em uso."
                        Icon={<InfoOutlinedIcon />}
                    />
                </Box>

                <Box sx={{ px: 2, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* Versão do app (frontend) */}
                    <Paper variant="outlined" sx={{ p: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Versão do Aplicativo
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Chip label={`v${appVersion}`} size="small" color="primary" variant="outlined" />
                        </Box>
                    </Paper>

                    {/* Informações do servidor — exibidas apenas se disponíveis */}
                    {product && (
                        <Paper variant="outlined" sx={{ p: 2 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Informações do Servidor
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {product.version && (
                                    <>
                                        <Divider />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" color="text.secondary">Versão do servidor</Typography>
                                            <Chip label={`v${product.version}`} size="small" variant="outlined" />
                                        </Box>
                                    </>
                                )}
                                {product.environment && (
                                    <>
                                        <Divider />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" color="text.secondary">Ambiente</Typography>
                                            <Chip
                                                label={product.environment}
                                                size="small"
                                                color={product.environment === 'production' ? 'success' : 'warning'}
                                                variant="outlined"
                                            />
                                        </Box>
                                    </>
                                )}
                                {product.buildDate && (
                                    <>
                                        <Divider />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" color="text.secondary">Data de build</Typography>
                                            <Typography variant="body2" fontWeight={500}>{product.buildDate}</Typography>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </Paper>
                    )}
                </Box>
            </Box>
        </div>
    );
};

export default About;
